import { PropertyChangedInformation, Notification } from '@app/shared';

@Notification({
    name: 'CategoryUpdatedNotification'
})
export class CategoryUpdatedNotification {
    public id: string;
    public name: string | null;
    public changes: PropertyChangedInformation[] = [];
}

@Notification({
    name: 'CategoryCreatedNotification'
})
export class CategoryCreatedNotification {1
    public id: string;
    public name: string | null;
    public changes: PropertyChangedInformation[] = [];
}
